import handleUpcoming from './handleUpcomingEvents.jsx';

export default () => {
  handleUpcoming();
};
